import Toast from '@/frontapp/mixins/actions/Toast'
import { $t } from 'nette-base-module/js/vuei18next'
import { FileApi } from '../../test-api/index.ts'
import handleApiError from '../../utils/handleApiError'

let canvaApiPromise = null
const fileApi = new FileApi({}, '/api/v2')

const loadApi = async function () {
  if (canvaApiPromise !== null) {
    return canvaApiPromise
  }

  canvaApiPromise = new Promise((resolve) => {
    var script = document.createElement('script')
    script.src = 'https://sdk.canva.com/designbutton/v2/api.js'
    script.onload = function () {
      if (window.Canva && window.Canva.DesignButton) {
        window.Canva.DesignButton.initialize({
          apiKey: 'CBjN8bDkbM5-O1hLo9uBg7e9',
        }).then(resolve)
      }
    }

    document.body.appendChild(script)
  })

  return canvaApiPromise
}

const savingFileNotification = function () {
  Toast(
    'info',
    $t('Saving file to BrandCloud...')
  ) 
}

const uploadRemoteFile = function (options, exportType, document) {
  return handleApiError(() => fileApi.fileRequestRemoteUpload({
    url: options.exportUrl,
    file_name: 'canva_' + options.designId + '.' + exportType,
    id_canva_design: options.designId,
    bc_document_id: document.documentId,
    bc_folder_id: document.folderId,
  
  })).then((uploadFileResponse) => {
    return handleApiError(() => fileApi.fileUploaded(uploadFileResponse.data.id))
  })
}

export async function createDesign(type, exportType, width, height, units, document) {
  const canvaApi = await handleApiError(() => loadApi())
  return new Promise((resolve, reject) => {
    let designId = '';
    let published = false;
    const design = {
      design: {
        type: type,
      },
      editor: {
        publishLabel: $t('Save to BrandCloud'),
        fileType: exportType,
      },
      onDesignOpen: function (options) {
        // Triggered when editor finishes loading and opens a new design.
        designId = options.designId
        // You can save designId for future use.
      },
      onDesignPublish: function (options) {
        // Triggered when design is published to an image.
        designId = options.designId
        published = true

        savingFileNotification()
        
        // Save the image to your server as the exportUrl will expire shortly.
        uploadRemoteFile(options, exportType, document).then((fileResponse) => {
          resolve({
            designId,
            file: fileResponse.data,
            document,
          })
        }, (error) => {
          reject(error)
        })
      },
      onDesignClose: function () {
        // Triggered when editor is closed.
        if (published === false) {
          resolve({
            designId,
            file: null,
            document
          })
        }
      },
    }

    if (width && height && units) {
      design.design.dimensions = {
        units,
        width,
        height,
      }
    }
    
    handleApiError(() => canvaApi.createDesign(design))
  })
}

export async function editDesign (designId, exportType, document) {
  const canvaApi = await handleApiError(() => loadApi())
  return new Promise((resolve, reject) => {
    let published = false;
    const design = {
      design: {
        id: designId,
      },
      editor: {
        publishLabel: $t('Save to BrandCloud'),
        fileType: exportType,
      },
      onDesignOpen: function (options) {
        // Triggered when editor finishes loading and opens a new design.
        designId = options.designId
        // You can save designId for future use.
      },
      onDesignPublish: function (options) {
        // Triggered when design is published to an image.
        designId = options.designId
        published = true;

        savingFileNotification()
        
         // Save the image to your server as the exportUrl will expire shortly.
        uploadRemoteFile(options, exportType, document).then((fileResponse) => {
          resolve({
            designId,
            file: fileResponse.data,
            document,
          })
        }, (error) => {
          reject(error)
        })
      },
      onDesignClose: function () {
        // Triggered when editor is closed.
        if (published === false) {
          resolve({
            designId,
            file: null,
            document,
          })
        }
      },
    }

    handleApiError(() => canvaApi.editDesign(design))
  })
}
  